import { Inject, Injectable } from '@angular/core';
import {
	ActivatedRoute,
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	RouteConfigLoadStart,
	Router,
	RouterEvent,
} from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { THEME_CONSTANTS } from '../1_settings/theme';
import { WINDOW, WindowRef } from './window.service';

@Injectable({
	providedIn: 'root',
})
export class AppService {
	loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	loadingFade$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

	constructor(private router: Router, private route: ActivatedRoute, @Inject(WINDOW) private window: WindowRef) {}

	checkRouterEvent(routerEvent: RouterEvent): void {
		if (routerEvent instanceof RouteConfigLoadStart) {
			this.loading$.next(true);
			this.loadingFade$.next(true);
		}

		if (
			routerEvent instanceof NavigationEnd ||
			routerEvent instanceof NavigationCancel ||
			routerEvent instanceof NavigationError
		) {
			this.loadingFade$.next(false);
			setTimeout(() => {
				this.loading$.next(false);
			}, parseInt(THEME_CONSTANTS.easings.default, 10));
		}

		if (routerEvent instanceof NavigationEnd) {
			this.router.navigate([], {
				relativeTo: this.route,
				queryParamsHandling: 'merge',
				queryParams: {
					nextUI: 'true',
				},
				replaceUrl: true,
			});
		}
	}
}
